import * as React from 'react'

function IconDownload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={47}
      height={45}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={47} height={45} rx={22.5} fill="#DDEBF4" />
      <path
        d="M35.57 17.79v7.706c0 3.996-3.209 7.234-7.169 7.234H18.303c-3.96 0-7.168-3.241-7.168-7.234V17.79M23.352 9.859v13.586"
        stroke="#1978B2"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M17.767 20.776l3.698 4.346a2.475 2.475 0 003.779 0l3.698-4.346"
        stroke="#1978B2"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconDownload
